export const tvs = [
  {
    id: "dark-river",
    title: "暗河",
    en: "Dark River",
    type: "tv",
    genres: ["悬疑", "犯罪"],
    region: "中国大陆",
    year: 2026,
    rating: 9.1,
    director: "沈默",
    cast: ["王砚", "高岑", "许知州", "蒋澜"],
    length: "36集",
    poster:
      "https://readdy.ai/api/search-image?query=cinematic%20vertical%20series%20poster%20artwork%20of%20a%20dark%20slow%20river%20winding%20through%20a%20foggy%20industrial%20town%20at%20dawn%20with%20a%20small%20boat%20silhouette%20and%20distant%20bridges%20mysterious%20investigative%20atmosphere%20muted%20deep%20navy%20and%20amber%20palette%20no%20text%20no%20lettering%20high%20detail&width=600&height=900&seq=rs-poster-darkriver&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=cinematic%20wide%20foggy%20industrial%20river%20at%20dawn%20with%20old%20bridges%20cranes%20and%20a%20small%20boat%20trailing%20a%20wake%20deep%20navy%20blue%20mist%20with%20warm%20amber%20street%20lights%20reflecting%20on%20water%20quiet%20tense%20atmosphere%20no%20text%20high%20detail&width=1600&height=900&seq=rs-hero-darkriver&orientation=landscape",
    intro: "一条河吞掉了十七年的秘密，也养活了整座城。",
    synopsis:
      "清水河下游发现一具被水泥封存的尸体，死者是十七年前那起沉船事故中失踪的船工。刑警队长魏东接手案件，发现当年的事故报告被人为改写，而参与调查的人如今都成了这座小城里有头有脸的人物。\n\n随着调查推进，魏东与搭档苏念逐渐触碰到一条横跨航运、地产与地方财政的利益链。河水每天照常上涨，证据却一件件消失。当唯一的证人选择沉默，他们必须决定，是用规则去赢，还是先破坏规则。",
    tags: ["刑侦", "小城", "群像"],
    reviews: [
      {
        author: "沈青",
        role: "剧评人",
        score: 9.3,
        title: "近几年最扎实的国产悬疑",
        excerpt: "没有故弄玄虚的反转，所有线索都摆在明面上，观众和警察一起被现实推着走。",
      },
      {
        author: "程野",
        role: "影视研究者",
        score: 9.0,
        title: "河流就是最大的反派",
        excerpt: "镜头反复拍摄水位线，那种缓慢上涨的无力感，比任何凶手都更让人窒息。",
      },
    ],
  },
  {
    id: "mountain-table",
    title: "山海食单",
    en: "A Table of Mountains and Seas",
    type: "tv",
    genres: ["剧情", "美食"],
    region: "中国大陆",
    year: 2025,
    rating: 8.7,
    director: "罗一凡",
    cast: ["叶承", "蒋雯青", "罗小满"],
    length: "24集",
    poster:
      "https://readdy.ai/api/search-image?query=cinematic%20vertical%20series%20poster%20artwork%20of%20a%20rustic%20chinese%20kitchen%20table%20with%20steaming%20clay%20pots%20fresh%20vegetables%20and%20warm%20lantern%20light%20hands%20preparing%20food%20overhead%20composition%20cozy%20atmospheric%20muted%20deep%20navy%20and%20warm%20amber%20palette%20no%20text%20no%20lettering%20high%20detail&width=600&height=900&seq=rs-poster-mountainfood&orientation=portrait",
    intro: "一道菜有一个来处，一个人有一张食单。",
    synopsis:
      "年轻厨师叶知白在城市里失意后回到闽南老家，接手外婆留下的小馆子。外婆留下的除了一本手写食单，还有半条街的旧账和一个不肯认他的舅舅。\n\n每一集围绕一道地方菜展开：红糟、土笋冻、面线糊、姜母鸭。食物是引子，真正被端上桌的是留下与离开、传承与改行、乡愁与体面。小馆子的灶火一直没熄，来吃饭的人也慢慢多了起来。",
    tags: ["美食", "乡土", "治愈"],
    reviews: [
      {
        author: "林未",
        role: "剧评人",
        score: 8.9,
        title: "把家常菜拍出了尊严",
        excerpt: "它不急着煽情，先让你看清一锅汤怎么熬，再让你明白这锅汤在为谁熬。",
      },
      {
        author: "白榆",
        role: "专栏作者",
        score: 8.6,
        title: "每条街都需要一间小馆子",
        excerpt: "群像写得极好，连只出现两集的送货小哥都有自己的来处。",
      },
    ],
  },
  {
    id: "latitude-30",
    title: "北纬三十度",
    en: "Latitude 30",
    type: "tv",
    genres: ["冒险", "悬疑"],
    region: "中国大陆",
    year: 2026,
    rating: 8.4,
    director: "高原",
    cast: ["韩旭", "唐婧", "陆丰"],
    length: "30集",
    poster:
      "https://readdy.ai/api/search-image?query=cinematic%20vertical%20series%20poster%20artwork%20of%20explorers%20with%20backpacks%20on%20a%20narrow%20mountain%20ridge%20above%20clouds%20at%20sunrise%20distant%20ancient%20stone%20markers%20sweeping%20landscape%20adventurous%20atmosphere%20muted%20deep%20navy%20and%20warm%20amber%20palette%20no%20text%20no%20lettering%20high%20detail&width=600&height=900&seq=rs-poster-latitude&orientation=portrait",
    intro: "沿着同一条纬线，有人在找答案，有人在藏答案。",
    synopsis:
      "地理纪录片团队沿着北纬三十度拍摄，途中在西南山区发现了一组不属于任何已知文明的石刻坐标。摄影师程野把照片发到网上，引来考古队、资本和一群不该出现的人。\n\n剧集采用双线叙事：一条是团队沿着纬线向东的旅程，一条是三十年前同一支路线的旧影像。两条线在第十集交叠，观众才发现，这场探险从出发那天起就是被安排好的。",
    tags: ["探险", "双线叙事", "地理"],
    reviews: [
      {
        author: "周衍",
        role: "类型剧观察者",
        score: 8.6,
        title: "国产冒险剧的一次升级",
        excerpt: "实景拍摄加分太多，山雾和海拔是真的，演员的喘息也是真的。",
      },
      {
        author: "Nora",
        role: "影视编辑",
        score: 8.2,
        title: "谜题之外还有人心",
        excerpt: "第十集的双线交汇处理得很漂亮，可惜后半段节奏略有松动。",
      },
    ],
  },
  {
    id: "old-street",
    title: "长街旧梦",
    en: "Old Street Dreams",
    type: "tv",
    genres: ["年代", "家庭"],
    region: "中国大陆",
    year: 2024,
    rating: 8.9,
    director: "李怀安",
    cast: ["周慕云", "沈曼", "季同", "何小满"],
    length: "42集",
    poster:
      "https://readdy.ai/api/search-image?query=cinematic%20vertical%20series%20poster%20artwork%20of%20a%20narrow%20chinese%20alley%20in%20the%201980s%20with%20old%20wooden%20shop%20fronts%20bicycles%20hanging%20laundry%20and%20warm%20evening%20light%20nostalgic%20film%20look%20muted%20deep%20navy%20and%20amber%20palette%20no%20text%20no%20lettering%20high%20detail&width=600&height=900&seq=rs-poster-oldstreet&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=cinematic%20wide%20view%20of%20a%20narrow%20old%20chinese%20neighborhood%20street%20in%20the%201980s%20with%20wooden%20shop%20fronts%20bicycles%20laundry%20lines%20and%20warm%20evening%20sunlight%20haze%20deep%20navy%20shadows%20with%20amber%20highlights%20nostalgic%20film%20texture%20no%20text%20high%20detail&width=1600&height=900&seq=rs-hero-oldstreet&orientation=landscape",
    intro: "一条街的三十年，装得下三代人的悲喜。",
    synopsis:
      "故事从1983年的长街开始。裁缝铺的女儿沈曼考上大学，成为整条街第一个走出去的人；留在家里的季同接了父亲的修表摊；而总在街口修自行车的何小满，偷偷喜欢着沈曼。\n\n四十二集跨越三十年，长街从热闹到冷清，从拆迁到改造。有人回来，有人再没回来。剧集不靠强情节推进，而是把时间放进每一件旧物里：一台缝纫机、一块停摆的表、一张贴了三次的春联。",
    tags: ["年代", "群像", "烟火气"],
    reviews: [
      {
        author: "顾南",
        role: "剧评人",
        score: 9.0,
        title: "国产年代剧的新坐标",
        excerpt: "它不美化过去，也不审判过去，只是认真地让那条街再亮一次灯。",
      },
      {
        author: "薛迟",
        role: "影评人",
        score: 8.8,
        title: "缝纫机的声音就是时间",
        excerpt: "全剧最动人的不是重逢，而是沈曼回到空铺子里，下意识地踩了两下踏板。",
      },
    ],
  },
  {
    id: "white-signal",
    title: "白色信号",
    en: "White Signal",
    type: "tv",
    genres: ["医疗", "剧情"],
    region: "韩国",
    year: 2025,
    rating: 8.5,
    director: "郑河",
    cast: ["朴瑞雨", "姜东勋", "李素熙"],
    length: "20集",
    poster:
      "https://readdy.ai/api/search-image?query=cinematic%20vertical%20series%20poster%20artwork%20of%20a%20hospital%20corridor%20at%20night%20with%20cold%20light%20spilling%20from%20a%20doorway%20and%20a%20doctor%20silhouette%20walking%20away%20quiet%20tense%20atmosphere%20clinical%20detail%20muted%20deep%20navy%20and%20pale%20amber%20palette%20no%20text%20no%20lettering%20high%20detail&width=600&height=900&seq=rs-poster-whitesignal&orientation=portrait",
    intro: "急诊室的灯从不熄灭，人的耐心会。",
    synopsis:
      "地方医院急诊科医生车瑞雨在一次夜班中，接收了一名身份不明的重伤患者。手术成功后，她发现这名患者的病历被人为清空，而当天值班的护士集体申请调岗。\n\n随着调查深入，一桩涉及医保结算与药品采购的旧案浮出水面。医院走廊依旧人来人往，每个人都在救人，也都在被系统推着往前走。",
    tags: ["医疗", "体制", "职业剧"],
    reviews: [
      {
        author: "韩知远",
        role: "剧评人",
        score: 8.7,
        title: "比手术更紧张的是排班表",
        excerpt: "它拍出了医疗剧少见的行政焦虑，那些表格和会议比血更让人喘不过气。",
      },
      {
        author: "梁一",
        role: "影视编辑",
        score: 8.3,
        title: "冷静的专业主义",
        excerpt: "没有天才医生开挂，只有一群普通人在有限条件下做正确的事。",
      },
    ],
  },
  {
    id: "fog-city-files",
    title: "雾都档案",
    en: "The Fog Files",
    type: "tv",
    genres: ["悬疑", "犯罪"],
    region: "英国",
    year: 2024,
    rating: 9.0,
    director: "艾米莉·肖",
    cast: ["托马斯·里德", "娜塔莉·布鲁克", "伊恩·福斯特"],
    length: "8集",
    poster:
      "https://readdy.ai/api/search-image?query=cinematic%20vertical%20series%20poster%20artwork%20of%20london%20rooftops%20in%20thick%20fog%20with%20a%20detective%20silhouette%20holding%20a%20folder%20and%20the%20glow%20of%20a%20distant%20window%20moody%20noir%20atmosphere%20muted%20deep%20navy%20and%20amber%20palette%20no%20text%20no%20lettering%20high%20detail&width=600&height=900&seq=rs-poster-fogfiles&orientation=portrait",
    intro: "档案不会说谎，整理档案的人会。",
    synopsis:
      "伦敦警局档案室管理员艾拉在一次数字化归档中，发现1987年的一宗失踪案卷宗被人抽走了四页。她按编号追查，发现同一时期还有六起案件存在相同的缺口。\n\n退休警探哈里森曾是这些案件的经办人，如今住在一间堆满旧报纸的公寓里。两个陌生人在雾里拼凑出四十年前的真相，也拼凑出彼此不愿提起的往事。八集限定剧，每集揭开一层。",
    tags: ["英剧", "冷案", "档案"],
    reviews: [
      {
        author: "Eva",
        role: "剧评人",
        score: 9.2,
        title: "今年最好的限定剧",
        excerpt: "它把破案过程拍成了一场关于记忆与官僚系统的对话，冷静到近乎残忍。",
      },
      {
        author: "陆遥",
        role: "影评人",
        score: 8.8,
        title: "雾是第四位主角",
        excerpt: "每一集开场的雾都不同，第三集那场几乎看不见人的长镜头，值得反复看。",
      },
    ],
  },
  {
    id: "star-postman",
    title: "星际邮差",
    en: "The Star Postman",
    type: "tv",
    genres: ["科幻", "剧情"],
    region: "美国",
    year: 2026,
    rating: 8.2,
    director: "卢卡斯·费恩",
    cast: ["奥莉维亚·格兰特", "马克·田", "诺亚·贝克"],
    length: "12集",
    poster:
      "https://readdy.ai/api/search-image?query=cinematic%20vertical%20series%20poster%20artwork%20of%20a%20small%20spacecraft%20drifting%20above%20a%20glowing%20blue%20planet%20with%20a%20lone%20astronaut%20floating%20near%20an%20open%20cargo%20hatch%20poetic%20sci%20fi%20atmosphere%20muted%20deep%20navy%20and%20warm%20amber%20palette%20no%20text%20no%20lettering%20high%20detail&width=600&height=900&seq=rs-poster-starpostman&orientation=portrait",
    intro: "在延迟三年的通信里，他送的是别人的一生。",
    synopsis:
      "星际邮政员凯尔负责在殖民星之间运送实体信件，因为光速延迟，一封信往往要走三年。他习惯了替陌生人转达迟到的好消息与坏消息，直到某一天，他收到一封写给自己的信，寄件人是三年前的他。\n\n十二集各自独立又互相咬合，每一集都是一封信、一个星球、一段无法及时回应的关系。飞船很小，宇宙很大，孤独被处理得很轻。",
    tags: ["太空", "单元剧", "孤独"],
    reviews: [
      {
        author: "周衍",
        role: "科幻评论者",
        score: 8.4,
        title: "温柔的太空剧",
        excerpt: "没有拯救宇宙，只有一封信到底要不要拆开，这种小尺度反而更打动人。",
      },
      {
        author: "Nora",
        role: "影视编辑",
        score: 8.0,
        title: "第五集可以单独封神",
        excerpt: "那封迟到十二年的道歉信，是全剧的情绪峰值，配乐克制得刚好。",
      },
    ],
  },
  {
    id: "alley-diner",
    title: "小巷食堂",
    en: "The Alley Diner",
    type: "tv",
    genres: ["治愈", "日常"],
    region: "日本",
    year: 2023,
    rating: 8.8,
    director: "森本葵",
    cast: ["田中静", "松本圭", "小林夏帆"],
    length: "16集",
    poster:
      "https://readdy.ai/api/search-image?query=cinematic%20vertical%20series%20poster%20artwork%20of%20a%20tiny%20japanese%20diner%20counter%20at%20night%20with%20steaming%20bowls%20warm%20hanging%20lights%20and%20an%20empty%20wooden%20stool%20intimate%20cozy%20atmosphere%20muted%20deep%20navy%20and%20warm%20amber%20palette%20no%20text%20no%20lettering%20high%20detail&width=600&height=900&seq=rs-poster-alleydiner&orientation=portrait",
    intro: "凌晨一点，只有这家店还亮着灯。",
    synopsis:
      "东京一条没有名字的小巷里，有一间只有八个座位的食堂，营业时间是深夜十一点到清晨五点。老板娘不问你从哪来，只问你要吃什么。\n\n每一集来一位客人：刚被裁员的上班族、跑完最后一班的出租车司机、准备离婚的夫妻、以及在城市里迷路的学生。一碗热汤、一份定食，加上几句闲话，天亮之后各自散去。",
    tags: ["深夜食堂", "单元剧", "治愈"],
    reviews: [
      {
        author: "林馥",
        role: "剧评人",
        score: 8.9,
        title: "把日常拍得很有分量",
        excerpt: "它从不劝人想开，只是把饭端上来，让人先吃饱再难过。",
      },
      {
        author: "苏念",
        role: "专栏作者",
        score: 8.7,
        title: "每个客人都只有一个背影",
        excerpt: "克制是全剧的美德，从不追问，也不替人总结人生。",
      },
    ],
  },
  {
    id: "against-light",
    title: "逆光而行",
    en: "Against the Light",
    type: "tv",
    genres: ["职场", "剧情"],
    region: "中国大陆",
    year: 2025,
    rating: 8.1,
    director: "方其",
    cast: ["陆行舟", "乔安", "周予"],
    length: "32集",
    poster:
      "https://readdy.ai/api/search-image?query=cinematic%20vertical%20series%20poster%20artwork%20of%20a%20modern%20office%20tower%20at%20dusk%20with%20one%20lit%20window%20and%20a%20businesswoman%20silhouette%20looking%20out%20over%20the%20city%20determined%20atmosphere%20muted%20deep%20navy%20and%20amber%20palette%20no%20text%20no%20lettering%20high%20detail&width=600&height=900&seq=rs-poster-againstlight&orientation=portrait",
    intro: "她想做的不是赢，是把事情做对。",
    synopsis:
      "建筑设计师程知微在一家老牌事务所工作十年，始终没能独立署名。一次竞标中，她发现公司提交的方案，是自己三年前被否掉的那份。\n\n她选择留下证据，也选择留下来。剧集不回避职场里的灰色地带：人情、站队、资源分配与看不见的天花板。程知微不是爽文女主，她会妥协，也会在关键处不退。",
    tags: ["职场", "女性", "建筑"],
    reviews: [
      {
        author: "白榆",
        role: "剧评人",
        score: 8.3,
        title: "终于有不悬浮的职场剧",
        excerpt: "会议室的每一句话都有分量，那些没说出口的暗示比争吵更真实。",
      },
      {
        author: "季川",
        role: "影视编辑",
        score: 7.9,
        title: "克制是它的优点也是缺点",
        excerpt: "后半段冲突处理得偏温和，但人物的选择始终立得住。",
      },
    ],
  },
  {
    id: "river-city",
    title: "江城旧事",
    en: "Tales of River City",
    type: "tv",
    genres: ["历史", "剧情"],
    region: "中国大陆",
    year: 2024,
    rating: 8.6,
    director: "闻少卿",
    cast: ["程寄北", "白秋", "沈砚舟"],
    length: "40集",
    poster:
      "https://readdy.ai/api/search-image?query=cinematic%20vertical%20series%20poster%20artwork%20of%20an%20old%20river%20port%20city%20with%20wooden%20boats%20stone%20stairs%20and%20factory%20chimneys%20in%20morning%20mist%20historical%20atmosphere%20muted%20deep%20navy%20and%20warm%20amber%20palette%20no%20text%20no%20lettering%20high%20detail&width=600&height=900&seq=rs-poster-rivercity&orientation=portrait",
    intro: "江水往东，故事往回。",
    synopsis:
      "民国二十六年，江城建起第一家纱厂。程家三兄妹分别走上了不同的路：大哥守着祖业，二姐投身报馆，三弟远走求学。四十年间，这座城经历了沦陷、光复与重建。\n\n剧集以一座城的变迁为经，以一个家庭的离散为纬。没有绝对的主角，每一集都有一封家书、一次迁徙、一场告别。江面上的汽笛声贯穿始终，像一段不会结束的旁白。",
    tags: ["民国", "家族", "年代"],
    reviews: [
      {
        author: "顾南",
        role: "历史剧研究者",
        score: 8.8,
        title: "把宏大叙事放回家书里",
        excerpt: "它不急于下判断，而是让人物在时代里自己走出一段路。",
      },
      {
        author: "薛迟",
        role: "影评人",
        score: 8.4,
        title: "汽笛声是最动人的配乐",
        excerpt: "每次汽笛响起，都意味着有人要走，这种重复形成了极强的情绪记忆。",
      },
    ],
  },
  {
    id: "silent-testimony",
    title: "无声证词",
    en: "Silent Testimony",
    type: "tv",
    genres: ["悬疑", "律政"],
    region: "中国香港",
    year: 2026,
    rating: 8.3,
    director: "邓志恒",
    cast: ["方澜", "罗天佑", "陈静仪"],
    length: "25集",
    poster:
      "https://readdy.ai/api/search-image?query=cinematic%20vertical%20series%20poster%20artwork%20of%20an%20empty%20courtroom%20with%20a%20single%20spotlight%20on%20a%20witness%20stand%20and%20documents%20scattered%20on%20a%20table%20tense%20legal%20drama%20atmosphere%20muted%20deep%20navy%20and%20amber%20palette%20no%20text%20no%20lettering%20high%20detail&width=600&height=900&seq=rs-poster-silenttestimony&orientation=portrait",
    intro: "法庭上最响的，往往是沉默。",
    synopsis:
      "律政新人方澜接到一宗看似简单的伤人案，被告是一名聋哑清洁工，全程拒绝配合，只反复写下一句话：我没有听见。\n\n随着庭审推进，手语翻译、监控缺失与证人改口，让案件越来越浑浊。方澜与资深检控官罗天佑从对立到合作，最终在法庭上用一段被忽略的环境音，还原了那个夜晚的真相。",
    tags: ["律政", "庭审", "香港"],
    reviews: [
      {
        author: "阿Ken",
        role: "剧评人",
        score: 8.5,
        title: "港剧庭审戏的一次回归",
        excerpt: "节奏干净，台词有锋，法庭戏的攻防写得比很多电影都讲究。",
      },
      {
        author: "温晴",
        role: "影视编辑",
        score: 8.1,
        title: "关注了被忽略的人",
        excerpt: "它没有把聋哑群体当作奇观，而是认真地讨论了沟通本身的不平等。",
      },
    ],
  },
  {
    id: "island-letters",
    title: "岛屿来信",
    en: "Letters from the Island",
    type: "tv",
    genres: ["爱情", "剧情"],
    region: "中国台湾",
    year: 2025,
    rating: 8.0,
    director: "陈映白",
    cast: ["江雨桐", "吴柏舟", "许青"],
    length: "18集",
    poster:
      "https://readdy.ai/api/search-image?query=cinematic%20vertical%20series%20poster%20artwork%20of%20a%20small%20island%20lighthouse%20at%20golden%20hour%20with%20a%20bicycle%20leaning%20on%20a%20stone%20wall%20and%20letters%20blowing%20in%20the%20wind%20romantic%20nostalgic%20atmosphere%20muted%20deep%20navy%20and%20warm%20amber%20palette%20no%20text%20no%20lettering%20high%20detail&width=600&height=900&seq=rs-poster-islandletters&orientation=portrait",
    intro: "岛上邮筒一天只开一次，足够装下一个人一整年的心事。",
    synopsis:
      "在离岛长大的邮差阿海，每天骑车环岛送信。他习惯替不识字的老人读信，也习惯把寄不出去的信收进自己的铁盒。\n\n从台北来的短期代课老师江雨桐，成了岛上唯一会认真回信的人。十八集的篇幅里，两个人通过一封封信慢慢靠近，也慢慢明白，有些距离不是靠喜欢就能跨过的。",
    tags: ["海岛", "书信", "慢节奏"],
    reviews: [
      {
        author: "苏念",
        role: "剧评人",
        score: 8.2,
        title: "慢得有道理",
        excerpt: "海风、邮筒、自行车，节奏刻意放慢，但情绪始终在往前走。",
      },
      {
        author: "陈映",
        role: "专栏作者",
        score: 7.8,
        title: "铁盒里的那些信",
        excerpt: "配角的故事比主线更好看，尤其是那位每天写同一封信的老先生。",
      },
    ],
  },
];